import {
  Blockquote,
  Button,
  Group,
  NumberInput,
  Paper,
  Stack,
  Text,
  ThemeIcon,
  Title,
  Tooltip,
} from "@mantine/core";
import React, { useState } from "react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import BackButton from "../../../../../components/View/BackButton";
import { DateTimePicker, TimeInput } from "@mantine/dates";
import {
  IconArrowRight,
  IconCalendarTime,
  IconClock,
  IconHelp,
  IconWiper,
} from "@tabler/icons-react";
import ProfileTimezone from "../../../../../components/View/ProfileTimezone";
import { defaultProgramData } from "../../../workflows/CreateCampaign/flow/flowSettings";
import { useFlowStore } from "../../../../../stores/WorkflowStore";

const NurturingProg = ({
  programData,
  setProgramData,
  setActiveStep,
  oldProgramData,
}) => {
  const lang = useLanguage((s) => s.language);
  const workflowProfile = useFlowStore((s) => s.profile);

  const isPast = oldProgramData
    ? new Date(oldProgramData.date_start) < new Date() &&
      oldProgramData?.workflow_id === workflowProfile?.id
    : false;

  const handleSubmit = (e) => {
    e.preventDefault();
    const fd = new FormData(e.target);
    const data = Object.fromEntries(fd);

    setActiveStep("workflow");
  };

  return (
    <Paper component={Stack} withBorder p={"lg"} gap={"sm"}>
      <Title order={4} ta={"center"}>
        {lang.prm.nurturing.step4.title}
      </Title>

      <Stack w="100%" mt={16} component={"form"} onSubmit={handleSubmit}>
        <Group gap={"xl"} justify="center">
          <Tooltip label={lang.campaign.already_programmed} disabled={!isPast}>
            <DateTimePicker
              dropdownType="modal"
              label={lang.workflows.program.step_config.date_start}
              defaultValue={
                programData?.date_start
                  ? new Date(programData.date_start)
                  : new Date()
              }
              onChange={(v) =>
                setProgramData({ ...programData, date_start: v })
              }
              leftSection={<IconCalendarTime />}
              rightSectionWidth={"auto"}
              rightSection={<ProfileTimezone disabled={isPast} />}
              w={400}
              name="date_start"
              valueFormat="DD MMM YYYY à HH:mm A"
              size="lg"
              radius={"md"}
              required
              disabled={isPast}
              minDate={new Date()}
            />
          </Tooltip>

          <TimeInput
            label={lang.workflows.program.step_config.time_start_sending}
            name="time_start_sending"
            size="lg"
            required
            defaultValue={
              programData?.time_start_sending
                ? programData.time_start_sending
                : defaultProgramData.time_start_sending
            }
            onChange={(e) =>
              setProgramData({
                ...programData,
                time_start_sending: e.target.value,
              })
            }
            leftSection={<IconClock />}
            radius={"md"}
            w={400}
            withSeconds
          />
        </Group>

        <Group gap={"xl"} mt={8} justify="center">
          <NumberInput
            label={lang.workflows.program.step_config.daily_send_limit}
            name="daily_send_limit"
            defaultValue={
              programData?.daily_send_limit
                ? programData.daily_send_limit
                : defaultProgramData.daily_send_limit
            }
            onChange={(v) =>
              setProgramData({ ...programData, daily_send_limit: v })
            }
            min={0}
            size="lg"
            w={400}
            leftSection={<IconWiper />}
            rightSectionWidth={50}
            rightSection={
              <Tooltip label={lang.campaign.limit_help}>
                <ThemeIcon size={"lg"}>
                  <IconHelp />
                </ThemeIcon>
              </Tooltip>
            }
          />

          <DateTimePicker
            dropdownType="modal"
            label={lang.workflows.program.step_config.more.date_stop}
            defaultValue={
              programData?.date_stop ? new Date(programData.date_stop) : null
            }
            onChange={(v) => setProgramData({ ...programData, date_stop: v })}
            leftSection={<IconCalendarTime />}
            rightSectionWidth={"auto"}
            rightSection={<ProfileTimezone />}
            w={400}
            name="date_stop"
            valueFormat="DD MMM YYYY à HH:mm A"
            size="lg"
            radius={"md"}
          />
        </Group>
      </Stack>

      <Group justify="center">
        <Blockquote p={"md"} mt={"md"} radius={"md"}>
          <Text size="lg">
            {lang.prm.nurturing.step4.text1} <br />{" "}
            {lang.prm.nurturing.step4.text2}
          </Text>
        </Blockquote>
      </Group>

      <Group mt={"md"} gap={"lg"} justify="center">
        <BackButton
          label={lang.global.back}
          onClick={() => setActiveStep("workflow")}
          size="md"
        />

        <Button
          onClick={() => setActiveStep("review")}
          size="md"
          rightSection={<IconArrowRight />}
        >
          {lang.global.next}
        </Button>
      </Group>
    </Paper>
  );
};

export default NurturingProg;
